module.exports = "//img1.rrcimg.com/_next/static/src/assets/consult-tel-red_Fvus6.gif";